import React from "react";
import { Heading, Flex } from "./style";
import SwapButton from "../components/SWAP/SwapButton";

const Header: React.FC = () => {
    
  return (
    <Flex>
      <Heading>Wallet</Heading>
      <SwapButton/>
    </Flex>
  );
};
export default Header;
